var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"inset":_vm.appConfig.footer.inset,"dark":_vm.appConfig.dark,"app":""}},[_c('span',{staticClass:"px-4"},[_vm._v("© "+_vm._s(new Date().getFullYear())),_c('strong',[_vm._v(" Gens ")]),_vm._v(". Todos los derechos reservados.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }